/**
 * Get current language or use fallback no > en
 **/
export const getCurrentLanguage = () => {
  return document.documentElement.lang ?? 'no, en';
};
